module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAAXNSR0IArs4c6QAAAGtJREFUSA1jYBgFoyFAoxBgRDL3PxKblkywnUy0tAGf2SxIkpOR2KPM0RAYuiGAnI+v0skb2iB7kC2mawGCnI/308nHo9aMhgBtQwA5O7XT1iq46ZUgFrLFdM3Hg6IhwAMPjFHGaAgM5RAAADHeBnR2WJO7AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/share/icon_menu.png
// module id = 1431
// module chunks = 2